// AuthContext.js
import React, { createContext, useEffect, useMemo, useState } from 'react';

const AuthContext = createContext({
  auth: false,
  token: null,
  username: null,
  user: null,
  course: null,
  login: () => {},
  logout: () => {},
  setUser: () => {},
  setCourse: () => {},
});

const STORAGE_TOKEN_KEY = 'auth_token';
const STORAGE_USERNAME_KEY = 'auth_username';

const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [username, setUsername] = useState(null);
  const [user, setUser] = useState(null);      // por si guardas más datos del usuario
  const [course, setCourse] = useState(null);  // lo que ya usabas

  // Cargar sesión desde localStorage al montar
  useEffect(() => {
    const t = localStorage.getItem(STORAGE_TOKEN_KEY);
    const u = localStorage.getItem(STORAGE_USERNAME_KEY);
    if (t) setToken(t);
    if (u) setUsername(u);
  }, []);

  const login = (jwtToken, name) => {
    if (!jwtToken) return;
    setToken(jwtToken);
    localStorage.setItem(STORAGE_TOKEN_KEY, jwtToken);

    if (name) {
      setUsername(name);
      localStorage.setItem(STORAGE_USERNAME_KEY, name);
    }
  };

  const logout = () => {
    setToken(null);
    setUsername(null);
    setUser(null);
    setCourse(null);
    localStorage.removeItem(STORAGE_TOKEN_KEY);
    localStorage.removeItem(STORAGE_USERNAME_KEY);
  };

  const auth = useMemo(() => Boolean(token), [token]);

  const value = {
    auth,
    token,
    username,
    user,
    course,
    login,
    logout,
    setUser,
    setCourse,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider };
